<template>
    <v-card flat>
        <v-layout column align-center justify-center my-3>
            <v-data-table 
                disable-sort
                :headers = 'header' 
                :items = 'grants' 
                no-data-text = 'Доступы не назначены' 
                :loading = 'indicator' 
                :server-items-length = 'grants.length' 
                hide-default-footer
            >
                <template v-slot:body = '{ items }'>
                    <tbody class = 'text-start'>
                        <tr v-for = "(item, i) in items" :key = "i">
                            <td>{{ item.project_name }}</td>
                            <td>{{ item.mode_name == '0'? 'Не подключен': item.mode_name}}</td>
                            <td>{{ item.r_name }}</td>
                            <td>{{ item.r_mode_name }}</td>
                            <td>{{ modes[item.r_mode_edit] }}</td>
                            <td>{{ modes[item.r_mode_persons] }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-layout>
    </v-card>
</template>

<script>
    export default {
        name: 'DistinctGrants',
        props: ['grants', 'indicator'],
        data: () => ({
            header: [
                { text: 'Проект', value: 'project_name' },
                { text: 'Роль в проекте', value: 'mode_name' },
                { text: 'Отчет', value: 'r_name' },
                { text: 'Роль в отчете', value: 'r_mode_name' },
                { text: 'Содержимое', value: 'r_mode_edit' },
                { text: 'Пользователи', value: 'r_mode_persons' }
            ],
            modes: {
                'X': 'Полный доступ',
                'U': 'Создание и редактирование',
                'W': 'Редактирование',
                'R': 'Просмотр'
            }
        })
    }
</script>